import { createFileRoute } from "@tanstack/react-router";
import Projects from "@/pages/Projects";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/projects")({
  head: () =>
    buildHead({
      title:
        "Projects | Before & After Projects | Precision Pavers & Pool Design",
      description:
        "Browse our portfolio of pool remodeling, deck resurfacing, driveway paver, and outdoor enhancement projects across Fort Lauderdale, Coral Springs, Weston, and Broward County. See the quality of Precision Pavers & Pool Design.",
      path: "/projects",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Our Projects",
            item: "https://precisionpaverspools.com/projects",
          },
        ],
      },
    }),
  component: Projects,
});
